var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{class:_vm.card_style},[_c('a-col',{class:_vm.card_style,attrs:{"span":24}},[_c('div',{class:['monitor-overview-card', _vm.card_style]},[_c('div',[_vm._t("header")],2),_c('div',{class:_vm.card_style},[_vm._t("default",function(){return [_vm._v(_vm._s(''))]})],2),_c('div',[_vm._t("footer")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }